<template>
  <div class="animated fadeIn">
      <b-row>
          <b-col sm="12">
               <b-button class="btn btn-sm btn-primary mr-4 btn-pill"  @click="openApprovePopup">
                  Transporter Master Approve Flow
                </b-button>
                 <b-button class="btn btn-sm btn-primary mr-4 btn-pill"  @click="openPushLogPopup('logdeatils')">
                    Push Log Transporter Finance
                  </b-button>
              <b-card  header-tag="header" footer-tag="footer">
                  <!-- <div slot="header">
                      <strong> Transporter Master </strong> 
                  </div> -->
                  
                  <b-row>
                      <b-col md="12">
                          <div>
                              <ul class="nav nav-tabs nav-justified">
                                  <li class="nav-item">
                                      <a @click="activeTab = 0"  class="nav-link " :class="{'active' : isActiveTab(0)}">Pending</a>
                                  </li>
                                  <li class="nav-item">
                                      <a @click="activeTab = 1"  class="nav-link " :class="{'active' : isActiveTab(1)}">Registered</a>
                                  </li>
                                  <li class="nav-item">
                                      <a @click="activeTab = 2"  class="nav-link " :class="{'active' : isActiveTab(2)}">Rejected</a>
                                  </li>
                              </ul>
                          </div>
                      </b-col>

                      <b-col md="12">
                          <div class="tab-panel" v-if="isActiveTab(0)">
                            <pendingIncident></pendingIncident>
                          </div>
                          <div class="tab-panel" v-if="isActiveTab(1)">
                            <approvalIncident></approvalIncident>
                          </div>
                  
                          <div class="tab-panel" v-if="isActiveTab(2)">
                                <rejectedIncident></rejectedIncident>
                          </div>
                      </b-col>
                  </b-row>
              </b-card>
          </b-col>
      </b-row>
    <!-- show Approve Popup Popup Modal -->
    <b-modal v-model="showApprovePopup" title="Transporter`s Approval Level">
        <div id="listloader" v-if="loader">
            <div class="listloader"></div>
            <br/>
            <span class="loading" style="color:#fff;">Loading...</span>
        </div>
        <table class="table table-bordered table-striped">
        <thead>
            <tr>
            <th>Approval Level</th>
            <th>Email(s)</th>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td>Level 1</td>
            <td>{{ approvalDatal1Email }}</td>
            </tr>
            <tr>
            <td>Level 2</td>
            <td>{{ approvalDatal2Email }}</td>
            </tr>
            <tr>
            <td>Level 3</td>
            <td>{{ approvalDatal3Email }}</td>
            </tr>
        </tbody>
        </table>
        <template #modal-footer >
        <b-button variant="secondary" @click="showApprovePopup = false">Close</b-button>
        </template>
    </b-modal>

    <!-- Push Log Finance Popup -->
    <b-modal v-model="showPushLogPopup" title="Push Log Finance" size="xl">
        <div id="listloader" v-if="loader">
            <div class="listloader"></div>
            <br />
            <span class="loading" style="color:#fff;">Loading...</span>
            
        </div>
        
            <div class="filter-section">
            <label for="statusFilter">Filter by Status:</label>
            <select id="statusFilter" v-model="selectedStatusInvoiceLog" @change="filterLogs">
                <option value="">All</option>
                <option value="New">Invoice Not Push</option>
                <option value="Success">Success</option>
                <option value="Error">Failed</option>
            </select>
            <a style="cursor: pointer; color: blue;" :href="cronToPushInvoiceDataToFinbees" target="_blank">
                Cron Vendor To Finbees
            </a>
            </div>
        <table class="table table-bordered">
        <thead>
            <tr>
            <th>Sr. No</th>
            <th>Created By</th>
            <th>Vendor ID</th>
            <th>Vehicle ID</th>
            <th>API URL</th>
            <th>Request</th>
            <th>Response</th>
            <th>Status</th>
            <th>Push Date</th>
            </tr>
        </thead>
        <tbody v-if="pushtotalCount.length">
            <tr v-for="(log, index) in pushLogData" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ log.createdby }}</td>
            <td>{{ log.vendorid }}</td>
            <td>{{ log.vehicleid }}</td>
            <td style="word-break: break-all;width:20%;">{{ log.url }}</td>
            <td style="word-break: break-all;width:40%;"><div class="scrollable-content">{{ log.body }}</div></td>
            <td style="word-break: break-all;width:20%;"> <div class="scrollable-content">{{ log.return_response }}</div></td>
            <td >{{ log.response_status ? log.response_status : 'New Invoice Cron Hit'}}</td>
            <td>{{ formatDate(log.createddate) }}</td>
            </tr>
        </tbody>
        <tbody v-else>
            <tr>
            <td colspan="9">No Record Found</td>
            </tr>
        </tbody>
        </table>
        <div>
        <!-- Pagination -->
        <b-pagination
            v-if="pushtotalCount > pushperPage"
            v-model="pushcurrentPage"
            :total-rows="pushtotalCount"
            :per-page="pushperPage"
            @change="getInvoicefinbeespushLog"
        ></b-pagination>
        </div>
        <template #modal-footer>
        <b-button variant="secondary" @click="showPushLogPopup = false">Close</b-button>
        </template>
    </b-modal>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import approvalIncident from '../components/transportalMaster/approvalIncident.vue'
import pendingIncident from '../components/transportalMaster/pendingIncident.vue'
import rejectedIncident from '../components/transportalMaster/rejectedIncident.vue'
export default {
  data() {
      return {
            activeTab: 0,
            approvalIncident,
            pendingIncident,
            rejectedIncident,
            showApprovePopup: false,
            approvalDatal1Email: "",
            approvalDatal2Email: "",
            approvalDatal3Email: "",
            showPushLogPopup: false,
            pushLogData: [], // Stores API log data
            pushperPage:10,
            pushtotalCount:0,
            pushcurrentPage:1,
            selectedStatusInvoiceLog:"",

      }
  },
  components : {
          approvalIncident,
          pendingIncident,
          rejectedIncident,
  },

  created: function() {
      this.isActiveTab(0);
  },
  computed: {   
      cronToPushInvoiceDataToFinbees() {
        return `${CONSTANTS.MIGRATION_API_URL}/cronToPushInvoiceDataToFinbees`;
      },
  },
  methods: {
  
  filterLogs() {
    this.pushcurrentPage = 1; // Reset to the first page
    this.getInvoicefinbeespushLog();
  },
    formatDate: function(date) {
        var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [year, month, day].join("-");
    },
  openPushLogPopup(type,value) {
      console.log(type)
      this.pushcurrentPage = 1;
      this.pushLogData = [];
      this.pushtotalCount = 0;
      this.showPushLogPopup = true;
      if (type=='tabledetails') {
        console.log("===========",value)
        this.getInvoicefinbeespushLog(1,value)
      } 
      else {
        this.getInvoicefinbeespushLog(1)
      }      
    },
    getInvoicefinbeespushLog(page = this.pushcurrentPage,data) {
       this.loader=true;
       this.pushcurrentPage = page; // Update current page
      // Add API call logic here to populate vehicleOptions
       try {
          const userdata = localStorage.getItem('userData');
          const userInfo = JSON.parse(userdata);

          var requestPayload = {
            page:this.pushcurrentPage,
            pageSize:this.pushperPage,
            invoiceno:(data ? data: ''),
            status: this.selectedStatusInvoiceLog,
            log_for:"vendor"
          };
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getInvoicefinbeespushLog`, requestPayload)
          .then(response => {
             this.loader=false;
             if (response.body.returnstatus==="Successful") {
                this.pushLogData = response.body.returnvalue;
                this.pushtotalCount = response.body.totalcount;
             } 
             else {
                this.pushLogData = [];
                this.pushtotalCount = 0;
             }
            
          }).catch(ex => {
                console.log("error-----", ex);
          });

      } catch (error) {
         this.loader=false;
        console.error('API call error:', error);
      }
    },
  getSystemUserByModule() {
      this.loader = true;
      const obj = {
        module: "vendor_onboarding",
        approverUser:'No'
      };

      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/getSystemUserByModule`, obj)
        .then((result) => {
          this.loader=false;
            if (result.body.returnstatus === "Successful") {
              const updatedDate = "2024-11-18";
             // Initialize a single approvalData object             
              var approvalOptions = result.body.returnvalue;
              this.approvalDatal1Email="";
              this.approvalDatal2Email= "";
              this.approvalDatal3Email= "";
              // Process the returnvalue to populate the single approvalData object
              approvalOptions.forEach(({ sysemailid, approval_action_filtered }) => {
                approval_action_filtered.forEach(({ level }) => {
                  if (level === "l1") {
                    this.approvalDatal1Email += this.approvalDatal1Email
                      ? `, ${sysemailid}`
                      : sysemailid;
                  } else if (level === "l2") {
                    this.approvalDatal2Email += this.approvalDatal2Email
                      ? `, ${sysemailid}`
                      : sysemailid;
                  } else if (level === "l3") {
                    this.approvalDatal3Email += this.approvalDatal3Email
                      ? `, ${sysemailid}`
                      : sysemailid;
                  }
                });
              });
             console.log(this.approvalDatal1Email);
            } else {
              this.approvalData = [];
            }
         }).catch((ex) => {
          console.log("error-----", ex);
        }).finally(() => {
          this.loader = false; // Stop loader when request completes
        });
    },

    openApprovePopup() {
      this.showApprovePopup = true;
          this.getSystemUserByModule();
    },
      isActiveTab(id)
      {
      return this.activeTab === id
      }
  }
}
</script>
<style scoped>
  .nav-link {
    background: #66635BAD !important;
    border-radius: 10px !important;
    margin-bottom: 20px;
  }
  .nav-link.active {
    background-color: #66635BAD !important;
    background: #00BDF0 !important;
    margin-bottom: 20px;
}
</style>